import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByMemberStsDataEdit',
  data: function data() {
    return {
      title: '',
      form: {
        stsId: null,
        memberId: null,
        shareUrlNum: null,
        inviteFriendsNum: null,
        releaseDynamicsNum: null,
        postQuestionsNum: null,
        answerQuestionsNum: null,
        privateMessagesNum: null,
        complaintNum: null,
        followNum: null,
        fabulousNum: null,
        visitorNum: null,
        giftNum: null,
        giftValue: null,
        giveGiftNum: null,
        giveGiftValue: null,
        createTime: null,
        downFabulousNum: null,
        datas: {}
      },
      rules: {}
    };
  },
  methods: {
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.stsId = null;
      this.form.memberId = null;
      this.form.shareUrlNum = null;
      this.form.inviteFriendsNum = null;
      this.form.releaseDynamicsNum = null;
      this.form.postQuestionsNum = null;
      this.form.answerQuestionsNum = null;
      this.form.privateMessagesNum = null;
      this.form.complaintNum = null;
      this.form.followNum = null;
      this.form.fabulousNum = null;
      this.form.visitorNum = null;
      this.form.giftNum = null;
      this.form.giftValue = null;
      this.form.giveGiftNum = null;
      this.form.giveGiftValue = null;
      this.form.createTime = null;
      this.form.downFabulousNum = null;
      this.form.angleOfAffinityNum = null;
      this.form.postCommentsNum = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.stsId = data.stsId + '';
      this.form.memberId = data.memberId + '';
      this.form.shareUrlNum = data.shareUrlNum + '';
      this.form.inviteFriendsNum = data.inviteFriendsNum + '';
      this.form.releaseDynamicsNum = data.releaseDynamicsNum + '';
      this.form.postQuestionsNum = data.postQuestionsNum + '';
      this.form.answerQuestionsNum = data.answerQuestionsNum + '';
      this.form.privateMessagesNum = data.privateMessagesNum + '';
      this.form.complaintNum = data.complaintNum + '';
      this.form.followNum = data.followNum + '';
      this.form.fabulousNum = data.fabulousNum + '';
      this.form.visitorNum = data.visitorNum + '';
      this.form.giftNum = data.giftNum + '';
      this.form.giftValue = data.giftValue + '';
      this.form.giveGiftNum = data.giveGiftNum + '';
      this.form.giveGiftValue = data.giveGiftValue + '';
      this.form.createTime = data.createTime + '';
      this.form.rechargeAmount = data.rechargeAmount;
      this.form.currencyNum = data.currencyNum;
      this.form.privateLetterNum = data.privateLetterNum;
      this.form.fansNum = data.fansNum;
      this.form.loginNum = data.loginNum;
      this.form.loginTime = data.loginTime;
      this.form.downFabulousNum = data.downFabulousNum;
      this.form.angleOfAffinityNum = data.angleOfAffinityNumInfo;
      this.form.postCommentsNum = data.postCommentsNum;
    },
    getMemberDatas: function getMemberDatas(member) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var pro, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              pro = {
                memberId: member.memberId
              };
              _context2.n = 1;
              return api.GET_BYMEMBERSTSDATA_INFO(pro);
            case 1:
              res = _context2.v;
              _this2.datas = res.body;
              _this2.datas.angleOfAffinityNumInfo = _this2.datas.angleOfAffinityNum;
              _this2.datas = Object.assign(_this2.datas, member);
              _this2.setData(_this2.datas);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateApi: function updateApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_BYMEMBERSTSDATA(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    saveApi: function saveApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.SAVE_BYMEMBERSTSDATA(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this5.form.stsId != null) {
            _this5.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this5.updateApi();
            }).catch(function () {
              _this5.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this5.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};